import { IconName } from '@infotech-soe/erp-ui-kit';

import {
  BuiltinCaptionType,
  Caption,
  CaptionType,
} from '../../../models/caption/Caption';

import CategoryCommand, { RefreshStrategy } from './CategoryCommand';

class FileLinkRecordCommand extends CategoryCommand<Record<string, any>> {
  public async getCaption(): Promise<Caption> {
    return {
      type: CaptionType.BUILT_IN,
      caption: BuiltinCaptionType.FILE_LINK,
    };
  }

  public getIcon(): IconName {
    return 'attach';
  }

  public getRefreshStrategy(): RefreshStrategy {
    return RefreshStrategy.CURRENT;
  }
}

export default FileLinkRecordCommand;
